import React, { Suspense } from 'react';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import PositionsTableSkeleton from 'components/data-containers/PositionsTable/SkeletonLoader';

import withForceBreakdownItem from 'helpers/withForceBreakdownItem';
import { TopicFilterNames } from 'components/TopicFilters/shared';
import { CompareModes } from 'context/entityContext';

const CurrentPositionsTable = React.lazy(() =>
  import('components/data-containers/PositionsTable/CurrentPositionsTable')
);

const PeakPositionsTable = React.lazy(() =>
  import('components/data-containers/PositionsTable/PeakPositionsTable')
);

interface IOfficialChartsProps {
  compareMode: CompareModes;
}

const allowedFilters: TopicFilterNames[] = ['country'];
const chartType = 'official';

const OfficialCharts: React.FC<IOfficialChartsProps> = (props) => {
  const { compareMode } = props;
  const isCompare = Boolean(compareMode);

  if (isCompare) {
    return (
      <Layout.MaxWidth>
        <Message>
          Unfortunately there are no other components available in compare mode
          on this topic for albums.
        </Message>
      </Layout.MaxWidth>
    );
  }

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <Suspense
        fallback={
          <PositionsTableSkeleton
            title="Chart Positions"
            productType="album"
            variation="currentPosition"
            short
          />
        }
      >
        <CurrentPositionsTable
          productType="album"
          title="Chart Positions"
          allowedFilters={allowedFilters}
          glossarySlug="charts-graphs-tables/position-table"
          chartType={chartType}
          short
        />
      </Suspense>

      <Suspense
        fallback={
          <PositionsTableSkeleton
            title="Peak Positions by Country"
            productType="album"
            variation="currentPosition"
          />
        }
      >
        <PeakPositionsTable
          productType="album"
          title="Peak Positions by Country"
          allowedFilters={allowedFilters}
          glossarySlug="charts-graphs-tables/position-table"
          chartType={chartType}
        />
      </Suspense>
    </div>
  );
};

export default withForceBreakdownItem(OfficialCharts as any);
